var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemToggle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.5 5.5a6.5 6.5 0 1 1 0 13h-7a6.5 6.5 0 1 1 0-13zm0 2h-7a4.5 4.5 0 0 0-.212 8.995l.212.005h7a4.5 4.5 0 0 0 .212-8.995zm0 1a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
})));
export default SvgGemToggle;